module.exports = __webpack_public_path__ + "static/media/giustino fortunato.fd2bdfda.png";